<template>
  <button class="inline-flex items-center justify-center px-4 py-1 font-medium text-gray-100 duration-100 border rounded-full border-text-gray-100 hover:border-white hover:text-white hover:bg-white/10">
    <slot />
  </button>
</template>
